export const mapSearch = ({ content, settings }): Content.ContentModule => ({
	documentType: content?.contentType,
	content: {
		properties: content?.properties ?? null,
	},
	settings: {
		properties: settings?.properties ?? null,
	},
});
